import styled from '@emotion/styled';
import {
  spacing,
  fontSize,
  borderRadius,
  mediaMax,
  fontWeight,
} from 'presentations/views/styles';
import { black, primary, white } from 'presentations/views/styles/color';
import { ResourceTaxonomyItem } from 'presentations/api/schema/resources';
import Link from 'presentations/views/components/atoms/Link';
import { translate } from 'infras/i18n';
import { resourceCategoryPath } from 'presentations/routes/path';

export interface Props {
  categories: ResourceTaxonomyItem[];
  className?: string;
}

export default function Component(props: Props) {
  if (props.categories.length === 0) {
    return null;
  }
  const categories = props.categories.filter((c) => c.slug !== 'blog');

  return (
    <CategoryList className={props.className}>
      {categories.map((category) => (
        <Category
          key={category.slug}
          href={resourceCategoryPath({ category: category.slug })}
        >
          {translate(`resource.category.${category.slug}`)}
        </Category>
      ))}
    </CategoryList>
  );
}

const CategoryList = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

const Category = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${spacing(4)};
  padding: ${spacing(2)} ${spacing(8)};

  /* background: ${black}; */
  border: 1px solid ${primary};
  box-sizing: border-box;
  border-radius: ${borderRadius(3)};
  font-weight: ${fontWeight('bold')};

  /* color: ${white}; */

  ${mediaMax.tablet} {
    font-size: ${fontSize(12)};
  }
`;
